import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function CTASection() {
  const { t } = useTranslation();
  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative rounded-3xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20digital%20email%20security%20concept%2C%20glowing%20envelope%20icons%20floating%20in%20dark%20deep%20teal%20space%2C%20network%20connections%20and%20data%20streams%2C%20futuristic%20minimal%20background%2C%20cinematic%20dark%20atmosphere%2C%208k%20resolution%2C%20professional%20CGI%20render&width=1200&height=400&seq=cta001&orientation=landscape"
            alt="CTA Background"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/30" />
          <div className="relative z-10 py-16 px-8 md:px-14 text-center md:text-left max-w-xl">
            <h2 className="text-3xl md:text-4xl font-extrabold text-white leading-tight mb-4">
              {t("home.cta_title")}
            </h2>
            <p className="text-white/70 text-sm leading-relaxed mb-8">{t("home.cta_subtitle")}</p>
            <Link
              to="/register"
              className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-semibold px-8 py-3.5 rounded-full cursor-pointer transition-all text-sm whitespace-nowrap"
            >
              {t("home.cta_btn")}
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
